/**
 * 代币统计 — GET /api/admin/stats/tokens
 */
import { Card, Col, Row, Statistic } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { TOKEN_IDS } from '@uo/shared';
import { api } from '../../api/client';

export function StatsTokenPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'stats', 'tokens'],
    queryFn: () => api.get<{ sums: Record<string, string> }>('/api/admin/stats/tokens'),
  });
  const sums = data?.sums ?? {};

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>代币统计</h2>
      <p style={{ color: '#666' }}>全站用户余额列合计（只读）。</p>
      <Row gutter={[12, 12]}>
        {TOKEN_IDS.map((t) => (
          <Col xs={12} sm={8} md={6} lg={4} key={t}>
            <Card size="small" loading={isLoading}>
              <Statistic title={t.toUpperCase()} value={sums[t] ?? '0'} />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
